export const environment = {
    production: true,
    _proxy: 'https://old-proxy.skillagentur.com/proxy',
    _proxy_bdm_news: 'https://news-proxy.skillagentur.com',
    dynamo_cms_proxy: 'https://dynamo-proxy.skillagentur.com/',
    gastroflow_proxy: 'https://service-proxy.skillagentur.com/',
};
